<template>
  <div
    v-masonry
    transition-duration="0.3s"
    item-selector=".card-item"
    
  >
    <iframe ref="ifram" width="100%"></iframe>
    <Card
      v-masonry-tile
      class="card-item"
      v-for="item in data"
      :key="item._id"
      :imgUrl="item.url"
      :fileName="item.name"
      @down="downLoadImg(item.url)"
    >
      <template slot="btn">
        <div class="model-btn" @click="changeName(item.img_id, item.sort_id, item.name)">修改命名</div>
        <div class="model-btn" @click="copyUrl(item.url)">复制外链</div>
        <div class="model-btn" @click="deleteImg(item._id)">删除</div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from "../Card/index.vue";
import {copy, down} from '../utils'
export default {
  components: {
    Card
  },
  props: {
    data: {
      type: Array,
      require: true
    }
  },
  watch: {
    data: {
      handler: function() {
        this.$nextTick(this.$redrawVueMasonry);
      },
      immediate: true
    }
  },
  methods: {
    confirm(options = {}) {
      const {
        titile = "",
        tip = "提示",
        callback = () => {},
        type = "$confirm",
        inputValue = ""
      } = options;
      return this[type](titile, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue,
        type: "warning",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            try {
              await callback();
              done();
            } catch (error) {
              error && this.$message.error(error.msg || error.message);
            }
            instance.confirmButtonLoading = false;
            instance.confirmButtonText = "确定";
          } else {
            done();
          }
        }
      });
    },
    changeName(id, sortId, imgName) {
      this.$prompt("请输入名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: imgName,
      }).then(({value})=>{
        this.handleChangeName(id, sortId, value)
      })
    },
    handleChangeName(imageId, sortId, name) {
      lib.tmsapi.post({
        api: "api/test/images/update",
        data: {
          imgId: imageId,
          sortId: sortId,
          name: name
        }
      }).then(()=>{
        const curItem = this.data.find(item=>item.img_id===imageId)
        if(curItem) {
          curItem.name = name
        }
      });
    },
    downLoadImg(url) {
      down(url).catch(error=>{
        this.$message.error({
          message: error.message,
          type: "error",
          center: true
        });
      })
    },
    copyUrl(url) {
      copy(url).then(()=>{
        this.$message.success({
          message: "原图外链已复制～",
          type: "info",
          center: true
        });
      })
    },
    deleteFn(img_id) {
      return lib.tmsapi.post({
        api: "api/test/images/delete",
        data: {
          img_id
        }
      });
    },
    // 确认删除图片
    deleteImg(id) {
      this.confirm({
        titile: "此操作将永久删除该文件, 是否继续?",
        callback: async() => {
          await this.deleteFn(id);
          this.$emit("delete");
          this.$message.success({
            message: "删除成功",
            type: "info",
            center: true
          });
        }
      })
    }
  },
  mounted() {
    if (this.$refs.ifram) {
      const ifWindow = this.$refs.ifram.contentWindow;
      ifWindow.addEventListener("resize", this.$redrawVueMasonry);
      this.$once("hook:beforeDestroy", () => {
        ifWindow.removeEventListener("resize", this.$redrawVueMasonry);
      });
    }
  }
};
</script>

<style scoped>
.card-item {
  margin-top: 16px;
  margin-right: 20px;
}
</style>
